import React from 'react';
import FacebookAuthButton from './Buttons/FacebookAuthButton';
import GoogleAuthButton from './Buttons/GoogleAuthButton';
import TwitterAuthButton from './Buttons/TwitterAuthButton';
import GithubAuthButton from './Buttons/GithubAuthButton';

function SocialLoginGroup() {
  return (
    <div className="social mt-3">
      <div className="form-group btn-showcase d-flex">
        {/* <FacebookAuthButton /> */}
        <GoogleAuthButton />
        {/* <TwitterAuthButton /> */}
        {/* <GithubAuthButton /> */}
      </div>
    </div>
  );
}

SocialLoginGroup.propTypes = {};

export default SocialLoginGroup;
